import { gql } from 'apollo-angular';

const dashboardSelection = `
        environment
        status
        appId
        startDate
        endDate
        totalEvents
        pageViews
        apiRequests
        uniqueSessions
        uniqueUsernames
        eventsByDay {
          date
          count
        }
        topPaths {
          path
          count
        }
        eventTypeBreakdown {
          eventType
          count
        }
        topCountries {
          label
          count
        }
        topBrowsers {
          label
          count
        }
        topOs {
          label
          count
        }
        topDevices {
          label
          count
        }
        topUsernames {
          label
          count
        }
        topCities {
          label
          count
        }
        topViewerAddresses {
          label
          count
        }
        topApiOperations {
          operationName
          operationType
          count
        }
        eventsByDayByEventType {
          date
          eventType
          count
        }
        kpiByDay {
          date
          totalEvents
          pageViews
          apiRequests
          uniqueSessions
          namedUserEvents
        }
        topNavigationFlows {
          steps
          count
        }
        performanceEventCount
        performanceByDay {
          date
          count
          avgLcp
          avgCls
          avgFcp
          avgTtfb
        }
        topPathsByLcp {
          path
          count
          avgLcp
          avgCls
          avgFcp
          avgTtfb
        }
        previousPeriod {
          totalEvents
          pageViews
          apiRequests
          uniqueSessions
          uniqueUsernames
        }
`;

const filterVariables = `,
      $filterEventType: String
      $filterUsername: String
      $filterCountry: String
      $filterBrowser: String
      $filterOs: String
      $filterDevice: String
      $filterCity: String
      $filterPath: String
`;

const filterArgs = `
        filterEventType: $filterEventType
        filterUsername: $filterUsername
        filterCountry: $filterCountry
        filterBrowser: $filterBrowser
        filterOs: $filterOs
        filterDevice: $filterDevice
        filterCity: $filterCity
        filterPath: $filterPath
`;

const dashboardExtraVariables = `,
      $includePreviousPeriod: Boolean
`;

const dashboardExtraArgs = `
        includePreviousPeriod: $includePreviousPeriod
`;

export class WebAnalyticsQueries {
  public static getDashboard = gql`
    query GetDashboard(
      $appId: String
      $startDate: String!
      $endDate: String!
      ${filterVariables}
      ${dashboardExtraVariables}
    ) {
      webAnalyticsDashboard(
        appId: $appId
        startDate: $startDate
        endDate: $endDate
        ${filterArgs}
        ${dashboardExtraArgs}
      ) {
        ${dashboardSelection}
      }
    }
  `;

  public static getAppIds = gql`
    query GetAppIds($startDate: String!, $endDate: String!) {
      webAnalyticsAppIds(startDate: $startDate, endDate: $endDate)
    }
  `;

  public static getActiveNow = gql`
    query GetActiveNow($appId: String, $windowMinutes: Int) {
      webAnalyticsActiveNow(appId: $appId, windowMinutes: $windowMinutes) {
        appId
        activeSessions
        activeNamedUsers
        windowMinutes
        asOf
      }
    }
  `;

  public static getUsers = gql`
    query GetUsers(
      $appId: String
      $startDate: String!
      $endDate: String!
      $search: String
      $sortBy: String
      $sortDescending: Boolean
      $limit: Int
      $offset: Int
      ${filterVariables}
    ) {
      webAnalyticsUsers(
        appId: $appId
        startDate: $startDate
        endDate: $endDate
        search: $search
        sortBy: $sortBy
        sortDescending: $sortDescending
        limit: $limit
        offset: $offset
        ${filterArgs}
      ) {
        totalCount
        users {
          username
          totalEvents
          sessions
          lastActive
          topEventType
          country
          city
          device
        }
      }
    }
  `;

  public static getUserDetail = gql`
    query GetUserDetail(
      $appId: String
      $username: String!
      $startDate: String!
      $endDate: String!
      $eventsLimit: Int
      $eventsCursor: String
      $eventsFilterEventType: String
      ${filterVariables}
    ) {
      webAnalyticsUserDetail(
        appId: $appId
        username: $username
        startDate: $startDate
        endDate: $endDate
        eventsLimit: $eventsLimit
        eventsCursor: $eventsCursor
        eventsFilterEventType: $eventsFilterEventType
        ${filterArgs}
      ) {
        username
        appId
        startDate
        endDate
        totalEvents
        sessions
        firstSeen
        lastSeen
        primaryDevice
        primaryBrowser
        primaryOs
        primaryCountry
        primaryCity
        eventsByDay {
          date
          count
        }
        eventsByDayByEventType {
          date
          eventType
          count
        }
        eventTypeBreakdown {
          eventType
          count
        }
        eventsPage {
          totalCount
          nextCursor
          hasMore
          events {
            timestamp
            eventType
            path
            referrer
            device
            browser
            os
            extra
            sessionId
          }
        }
      }
    }
  `;
}
